<template>
  <div
    ref="main"
    :class="{
      card,
      'card-alt': cardAlt,
      dark: isDark,
      'episodes-alt': episodesAlt,
      landscape,
      portrait,
      'text-large': textLarge,
      'text-medium': textMedium,
      'text-small': textSmall,
      'text-extra-small': textExtraSmall
    }"
    :style="playerStyles"
    class="main"
  >
    <Audio />

    <Artwork
      v-if="artSide"
      :style="artworkStyles"
      class="artSide"
    />

    <div
      :style="metaControlsStyles"
      class="artwork-meta-controls">
      <div class="artwork-meta-controls-inner">
        <Artwork
          v-if="artEmbed"
          :style="artworkStyles"
          class="artEmbed"
        />

        <div class="meta-controls">
          <Artwork
            v-if="artAbove"
            :style="artworkStyles"
            class="artAbove"
          />

          <div
            :class="[{'meta-controls-wrap': true, hide: showSubscribe || showShare}]">
            <Logo />
            <div class="meta-wrapper">
              <Artwork
                v-if="metaArt"
                :style="artworkStyles"
                class="metaArt"
              />
              <MetaInfo />
            </div>

            <div class="play-pause-controls">
              <PlayPause />

              <div class="scrubber-controls">
                <Scrubber />

                <div class="controls">
                  <Speed />

                  <div class="middle">
                    <Rewind />
                    <Forward />
                  </div>

                  <div class="right">
                    <Share />
                    <Subscribe />
                  </div>
                </div>
              </div>
            </div>
            <transition name="fade">
              <SharePanel v-if="showShare" />
              <SubscribePanel v-if="showSubscribe" />
            </transition>
          </div>
        </div>
      </div>

      <Episodes />
    </div>
  </div>
</template>

<script>
import Artwork from './Artwork'
import Audio from './Audio'
import Episodes from './Episodes'
import Forward from './Forward'
import Logo from './Logo'
import MetaInfo from './MetaInfo'
import PlayPause from './PlayPause'
import Rewind from './Rewind'
import Scrubber from './Scrubber'
import Share from './Share'
import Subscribe from './Subscribe'
import Speed from './Speed'
import Store from '../store'
import SubscribePanel from './SubscribePanel'
import SharePanel from './SharePanel'

export default {
  components: {
    Artwork,
    Audio,
    Episodes,
    Forward,
    Logo,
    MetaInfo,
    PlayPause,
    Rewind,
    Scrubber,
    Share,
    Subscribe,
    Speed,
    SubscribePanel,
    SharePanel
  },
  data () {
    return {
      main: false,
      innerHeight: 0,
      innerWidth: 0,
      offsetHeight: 0,
      offsetWidth: 0,
      store: Store
    }
  },
  computed: {
    artworkStyles () {
      if (this.landscape) {
        return {
          'flex-basis': `${this.innerHeight}px`,
          'max-width': `${this.innerHeight}px`
        }
      }

      return false
    },
    metaControlsStyles () {
      if (this.landscape) {
        return {
          'flex-basis': `calc(100% - ${this.innerHeight + 15}px)`,
          'max-width': `calc(100% - ${this.innerHeight + 15}px)`
        }
      }

      return false
    },
    artSide () {
      if (this.offsetHeight < 640 && this.offsetWidth >= 810) return true
      if (this.offsetHeight >= 640 && this.offsetHeight < 800 && this.offsetWidth >= 1150) return true
      if (this.offsetHeight >= 800 && this.offsetWidth >= 1280) return true

      return false
    },

    artEmbed () {
      if (this.offsetHeight < 640 && this.offsetWidth < 810 && this.offsetWidth >= 600) return true
      if (this.offsetHeight >= 640 && this.offsetHeight < 800 && this.offsetWidth >= 600 && this.offsetWidth < 1150) return true
      if (this.offsetHeight >= 800 && this.offsetWidth >= 600 && this.offsetWidth < 1280) return true

      return false
    },
    metaArt () {
      if (this.offsetHeight < 640 && this.offsetWidth < 600) return true
      if (this.offsetHeight >= 640 && this.offsetHeight < 600 && this.offsetWidth >= 480) return true

      return false
    },
    artAbove () {
      if (this.offsetHeight >= 640 && this.offsetHeight < 800 && this.offsetWidth < 480) return true
      if (this.offsetHeight >= 800 && this.offsetWidth < 600) return true

      return false
    },
    // Card styles: Artwork top left, with playlist underneath
    card () {
      if (this.offsetHeight < 640 && this.offsetWidth < 810) return true
      if (this.offsetHeight >= 640 && this.offsetHeight < 800 && this.offsetWidth >= 480 && this.offsetWidth < 1150) return true
      if (this.offsetHeight >= 800 && this.offsetWidth >= 600 && this.offsetWidth < 1280) return true

      return false
    },
    // Card styles: Artwork top left, play/pause/waveform underneath and playlist underneath
    cardAlt () {
      if (this.card && this.offsetWidth < 600) return true

      return false
    },
    // Handles whether the controls are floating to the right of the waveform or not
    controlsAlt () {
      if (this.offsetWidth < 480) return true
      if (this.offsetWidth >= 1150 && this.offsetWidth < 1024 && this.offsetHeight >= 640 && this.offsetHeight < 800) return true

      return false
    },
    episodesAlt () {
      if (this.offsetWidth < 480) return true

      return false
    },
    isDark () { return this.store.state.isDark },
    // Artwork fills entire left side
    landscape () {
      if (this.offsetHeight < 640 && this.offsetWidth >= 810) return true
      if (this.offsetHeight < 800 && this.offsetWidth >= 1150) return true
      if (this.offsetWidth >= 1280) return true

      return false
    },
    playerStyles () {
      return {
        background: this.store.state.color
      }
    },
    playSmall () {
      if (this.offsetWidth < 480 && this.offsetHeight < 800) return true
      if (this.offsetWidth < 600 && this.offsetHeight >= 800) return true

      return false
    },
    // Artwork fills entire top area
    portrait () {
      if (this.offsetHeight >= 640 && this.offsetWidth < 480) return true
      if (this.offsetHeight >= 800 && this.offsetWidth < 600) return true

      return false
    },
    showSubscribe () {
      return this.store.state.showSubscribe
    },
    showShare () {
      return this.store.state.showShare
    },
    textExtraSmall () {
      if (this.offsetWidth < 480 && this.offsetHeight < 640) return true

      return false
    },
    textLarge () {
      if (this.offsetWidth >= 1920 && this.offsetHeight >= 640) return true
      if (this.offsetWidth >= 1440 && this.offsetHeight >= 800) return true

      return false
    },
    textMedium () {
      if (this.offsetWidth >= 810 && this.offsetWidth < 1920 && this.offsetHeight >= 640 && this.offsetHeight < 800) return true
      if (this.offsetWidth >= 810 && this.offsetWidth < 1440 && this.offsetHeight >= 640) return true

      return false
    },
    textSmall () {
      if (this.offsetWidth >= 480 && this.offsetHeight < 640) return true
      if (this.offsetWidth < 810 && this.offsetHeight >= 640) return true

      return false
    }
  },
  created () {
    window.addEventListener('resize', this.setOffsets)
  },
  beforeDestroy () { window.removeEventListener('re10size', this.setOffsets) },
  mounted () {
    this.setOffsets()
  },
  methods: {
    setOffsets () {
      const style = window.getComputedStyle(this.$refs.main, null)
      const height = parseInt(style.getPropertyValue('height').replace('px', ''))
      const padding = parseInt(style.getPropertyValue('padding').replace('px', '')) || 0
      const border = parseInt(style.getPropertyValue('border-width').replace('px', '')) || 0
      this.innerHeight = height - (padding * 2) - (border * 2)
      this.offsetWidth = this.$refs.main.offsetWidth + (padding)
      this.offsetHeight = this.$refs.main.offsetHeight
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.simplecast-playlist .main {
  .meta-wrapper {
    display: flex;
  }
  .meta-info {
    overflow: hidden;

    h1 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  &.controls-alt {
    .controls-share {
      svg {
        display: flex;
      }
      .share-text {
        display: none;
      }
    }
  }
  &.episodes-alt {
    .duration,
    .number {
      @include font-xs();
    }
    .title {
      @include font-m-embed(700);
    }
  }

  &.text-extra-small {
    h1 { @include font-m-embed(700); }
    h2 { @include font-xxs(); }
  }
  &.text-small {
    h1 { @include font-xl-embed(700); }
    h2 { @include font-xs(); }
  }
  &.text-medium {
    h1 {
      @include font-xl-embed(700);

      // Overriding because our base font library doesn't really
      // fit with the playlist player
      font-size: 32px;
      line-height: 36px;
    }
    h2 { @include font-m-mono(); }
  }
  &.text-large {
    h1 {
      @include font-xl-embed(700);

      // Overriding because our base font library doesn't really
      // fit with the playlist player
      font-size: 40px;
      line-height: 48px;
    }
    h2 { @include font-l-mono(); }
  }
}
</style>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';
@import '../assets/styles/breakpoints.scss';

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.main {
  background: $white-000;
  border: solid 2px $black-trans-100;
  border-radius: 2px;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  padding: 15px;
  a, button {
    transition: opacity .2s ease-in-out;
    &:focus {
      outline: 0;
      opacity: .6;
    }
  }

  &.card {
    &.card-alt {
      .meta-controls-wrap {
        width: 100%;
      }
      .artwork {
        // Don't use the margin amount
        flex-basis: calc(25% - 15px);
        min-width: 76px;
      }
      .artwork-meta-controls {
        flex-direction: column;
      }
      .episodes {
        flex-basis: 0;
      }
      .meta-controls {
        align-content: flex-start;
        flex-direction: row;
        flex-wrap: wrap;
        position: relative;

        .meta-info {
          flex-basis: calc(75% - 91px);
          width: 100%;
          @media (min-width: $bp_xs) {
            flex-basis: 75%;
          }
        }
        .play-pause-controls {
          margin-bottom: 5px;
          width: 100%;
        }

      }
    }
    .artwork {
      flex-basis: 28%;
      margin: 0 15px 15px 0;
    }
    .artwork-meta-controls {
      display: flex;
      flex: 1;
      flex-direction: column;
      max-width: 100%;
    }
    .artwork-meta-controls-inner {
      display: flex;
    }
    .logo {
      right: 0;
      top: 0;
    }
    .meta-controls {
      flex: 1;
      position: relative;
      margin-bottom: 15px;
      &_info {
        width: 100%;
      }
    }
    .meta-info {
      margin-bottom: 25px;
    }
  }
  &.landscape {
    .artwork {
      flex: 1;
      margin-right: 15px;
    }
    .artwork-meta-controls {
      display: flex;
      flex: 1;
      flex-direction: column;

      .artwork {
        display: none;
      }
    }
    .meta-controls {
      margin-bottom: 20px;
      position: relative;
    }
    .logo {
      right: 0;
      top: 0;
    }
    .meta-info {
      margin-bottom: 20px;
    }
    .play-pause-controls {
      margin-bottom: 5px;
    }
  }
  &.portrait {
    flex-direction: column;

    .artwork {
      margin-bottom: 10px;
    }
    .artwork-meta-controls {
      display: flex;
      flex: 1;
      flex-direction: column;
      max-height: 100%;
    }
    .meta-controls {
      margin-bottom: 10px;
      position: relative;
    }
    .meta-info {
      margin-bottom: 20px;
    }
    .logo {
      right: 0;
      top: 0;
    }
  }
}
.logo {
  height: 20px;
  width: 20px;
}
.meta-controls {
  display: flex;
  flex-direction: column;
  position: relative;

  .meta-controls-wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
    opacity: 1;
    transition: opacity .5s;
    position: relative;
    padding: 1px;
    .hide {
      opacity: 0;
    }
  }
  .subscribe-panel {
    border-width: 1px;
    z-index: 1000;

    /deep/ .title-close {
      justify-content: flex-end;
    }
    /deep/ .artwork-meta {
      display: none;
    }
  }
}
.play-pause-controls {
  align-items: flex-end;
  display: flex;
  flex-grow: 1;

  .middle {
    .controls-alt & {
      display: none;
    }
  }
  .controls-speed,
  .controls-share {
    .controls-alt & {
      height: 16px;
      text-align: center;
      width: 32px;

      line-height: 10px;
    }
  }
  .controls-speed {
    .controls-alt & {
      margin-bottom: 4px;
    }
  }
  .scrubber-controls {
    flex: 1;
    height: 76px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .controls-alt & {
      display: flex;
    }
    .controls {
      padding-bottom: 2px;
      align-items: center;
      display: flex;
      opacity: .95;
      transition: opacity .2s ease-in-out;

      .controls-alt & {
        align-items: stretch;
        flex-direction: column;
        padding-left: 8px;
      }
      .controls-forward,
      .controls-rewind {
        display: inline-flex;
        align-items: center;
        &:focus {
          opacity: .75;
        }
      }
      .middle {
        flex: 1;
        display: flex;
        align-items: center;
        text-align: left;
        box-sizing: border-box;
        padding-left: 24px;
        transition: opacity .2s ease-in-out;
      }
      .right {
        height: 20px;
        display: flex;
        align-items: flex-end;
      }
    }
    &:hover {
      .controls-forward,
      .controls-rewind {
        opacity: .75;
      }
    }
  }
  .play-pause {
    align-self: flex-end;
    height: 76px;
    margin-right: 14px;
    width: 75px;
    min-width: 75px;

    &.play-small {
      height: 37px;
      margin-right: 8px;
      width: 36px;
      min-width: 36px;
    }
  }
}
</style>
